const SET_CURRENT_RECORD_ID = 'SET_CURRENT_RECORD_ID';
export const setCurrentRecordId = recordId => dispatch => {
  dispatch({ type: SET_CURRENT_RECORD_ID, recordId });
};

const RESET_CURRENT_RECORD_ID = 'RESET_CURRENT_RECORD_ID';
export const resetCurrentRecordId = () => dispatch => {
  dispatch({ type: RESET_CURRENT_RECORD_ID });
};

const SET_LOADING_POLICY_TYPE_ID = 'SET_LOADING_POLICY_TYPE_ID';
export const setLoadingPolicyTypeId = policyTypeId => dispatch => {
  dispatch({ type: SET_LOADING_POLICY_TYPE_ID, policyTypeId });
};

const REMOVE_LOADING_POLICY_TYPE_ID = 'REMOVE_LOADING_POLICY_TYPE_ID';
export const removeLoadingPolicyTypeId = policyTypeId => dispatch => {
  dispatch({ type: REMOVE_LOADING_POLICY_TYPE_ID, policyTypeId });
};

const SET_LOADING_DOCUMENT_TYPE_ID = 'SET_LOADING_DOCUMENT_TYPE_ID';
export const setLoadingDocumentTypeId = documentTypeId => dispatch => {
  dispatch({ type: SET_LOADING_DOCUMENT_TYPE_ID, documentTypeId });
};

const REMOVE_LOADING_DOCUMENT_TYPE_ID = 'REMOVE_LOADING_DOCUMENT_TYPE_ID';
export const removeLoadingDocumentTypeId = documentTypeId => dispatch => {
  dispatch({ type: REMOVE_LOADING_DOCUMENT_TYPE_ID, documentTypeId });
};

const DEFAULT_STATE = { currentRecordId: null, loadingPolicyTypeIds: {}, loadingDocumentTypeIds: {} };

const insuredProfilePageReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SET_CURRENT_RECORD_ID:
      return {
        ...state,
        currentRecordId: parseInt(action.recordId, 10)
      };
    case SET_LOADING_POLICY_TYPE_ID:
      return {
        ...state,
        loadingPolicyTypeIds: {
          ...state.loadingPolicyTypeIds,
          [action.policyTypeId]: true
        }
      };
    case REMOVE_LOADING_POLICY_TYPE_ID: {
      if (state.loadingPolicyTypeIds[action.policyTypeId]) {
        const newObject = state.loadingPolicyTypeIds;

        delete newObject[action.policyTypeId];

        return {
          ...state,
          loadingPolicyTypeIds: newObject
        };
      }

      return state;
    }

    case SET_LOADING_DOCUMENT_TYPE_ID:
      return {
        ...state,
        loadingDocumentTypeIds: {
          ...state.loadingDocumentTypeIds,
          [action.documentTypeId]: true
        }
      };
    case REMOVE_LOADING_DOCUMENT_TYPE_ID: {
      if (state.loadingDocumentTypeIds[action.documentTypeId]) {
        const newObject = state.loadingDocumentTypeIds;

        delete newObject[action.documentTypeId];

        return {
          ...state,
          loadingDocumentTypeIds: newObject
        };
      }

      return state;
    }

    case RESET_CURRENT_RECORD_ID:
      return {
        ...state,
        currentRecordId: null
      };
    default:
      return state;
  }
};

export const selectCurrentRecordId = state => state.insuredProfilePage.currentRecordId;
export const selectCurrentJobId = state => state.insuredProfilePage.currentJobId;
export const selectPolicyTypeIdIsLoading = policyTypeId => state => state.insuredProfilePage.loadingPolicyTypeIds[policyTypeId];

export default insuredProfilePageReducer;
